import { QueryLayout } from "common/components/Layout/QueryLayout";
import { Title } from "common/components/Title/Title";
import { FC } from "react";
import { NavLink } from "react-router-dom";
import { useGetTermsQuery } from "services/appApi";

export const PoliticsPage: FC<{ applicationId: number }> = ({
  applicationId,
}) => {
  const { data, isLoading, error, isFetching } =
    useGetTermsQuery(applicationId);

  return (
    <section className="absolute top-0 bottom-0 left-0 right-0 z-10 flex h-full flex-col bg-white py-[20px] px-[15px]">
      <Title>Политика конфиденциальности</Title>
      <div className="mb-[15px] text-sm text-gray">
        <NavLink to="/">Главная</NavLink> / Политика конфиденциальности
      </div>
      <div className="grid gap-[15px] rounded border border-lightWhiteGray p-[15px] leading-[17px] text-lightGray">
        <QueryLayout
          isLoading={isLoading}
          isFetching={isFetching}
          error={error}
        >
          {data?.map((term) => (
            <p key={term.id}>{term.content}</p>
          ))}
        </QueryLayout>
      </div>
    </section>
  );
};
